import aula from './aula'
import webinar from './webinar'
import podcast from './podcast'
import capitulo from './capitulo'
import artigo from './artigo'
import diretriz from './diretriz'
import tabela from './tabela'
import fluxograma from './fluxograma'
import figura from './figura'
import medicamento from './medicamento'
import consultaRapidaERecomendacoes from './consultaRapidaERecomendacoes'
import diagnosticoETratamento from './diagnosticoETratamento'
import habilidadesClinicas from './habilidadesClinicas'
import withFields from './withFields'
import commonFields from './commonFields'

const contentSchema = {
  aula: withFields(aula)(commonFields),
  webinar: withFields(webinar)(commonFields),
  podcast: withFields(podcast)(commonFields),
  capitulo: withFields(capitulo)(commonFields),
  artigo: withFields(artigo)(commonFields),
  diretriz: withFields(diretriz)(commonFields),
  tabela: withFields(tabela)(commonFields),
  fluxograma: withFields(fluxograma)(commonFields),
  figura: withFields(figura)(commonFields),
  medicamento: withFields(medicamento)(commonFields),
  'consulta_rapida_e_recomendacoes': withFields(consultaRapidaERecomendacoes)(commonFields),
  'diagnostico_e_tratamento': withFields(diagnosticoETratamento)(commonFields),
  'habilidades_clinicas': withFields(habilidadesClinicas)(commonFields)
}

export default contentSchema



// WEBPACK FOOTER //
// ./src/contentSchema/index.js